import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { WebApiService } from "../../../_libs/web-api";
import { BaseWebApiService } from "./-base-webapi.service";

@Injectable({
	providedIn: "root"
})
export class MuleHealthService extends BaseWebApiService {
	constructor(private webApiService: WebApiService) {
		super();
	}

	public muleHealth(uri: string): Observable<any> {
		const url = "health";

		return this.webApiService.getMuleHealth(
			this.valueReplacer(url, [""], [encodeURIComponent("".trim())])
		);
	}
}
